export default __webpack_public_path__ + "locales/ja-JP/FillPDFDialog.json?hash=d4389af20d49afbe12f02cdb6df529f2";